import React, { useContext, useEffect, useState } from 'react'
import ListContext from '../../context/list/ListContext'
import StoreContext from '../../context/store/StoreContext'
import { ListChoice } from './ListChoice'
import { Link } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'

export const ListPickPage = ({ shopClick }) => {
  const listContext = useContext(ListContext)
  const storeContext = useContext(StoreContext)

  const { lists, getLists } = listContext
  const { stores, getStores } = storeContext

  const [visible, setVisible] = useState(false)
  const [loading, setLoading] = useState(false)
  const [theseStores, setTheseStores] = useState([])

  const navigate = useNavigate()

  useEffect(() => {
    setLoading(true)
    const loadData = async () => {
      await getLists()
      const stores = await getStores()
      setTheseStores(stores)
    }
    loadData()
    setLoading(false)
    // M.AutoInit()

    // eslint-disable-next-line
  }, [])

  const visibilityClick = () => {
    setLoading(true)
    setVisible(!visible)
    console.log('visibility', visible)
    setLoading(false)
  }

  const navigateToNewList = () => {
    navigate('/newlist', { replace: true })
  }

  let listStatus

  if (lists.length === 0) {
    listStatus = (
      <h4 className="text-center">
        No lists yet... <Link to="/newlist">Create one!</Link>
      </h4>
    )
  } else if (
    lists.map((list) => list.shopped).every((shopped) => shopped) &&
    !visible
  ) {
    listStatus = (
      <>
        <div className="text-center">🎉 All lists shopped! 🎉</div>
        <div onClick={() => navigateToNewList()}>Create a new one!</div>
        <div
          className="text-xl"
          onClick={() => visibilityClick()}
        >
          View shopped lists
        </div>
      </>
    )
  } else {
    listStatus = lists.map((list) => (
      <ListChoice
        key={list._id}
        shopClick={shopClick}
        list={list}
        visible={visible}
        store={
          theseStores &&
          theseStores.find(
            (store) => store && list.store && store._id === list.store._id
          )
        }
      />
    ))
  }

  return (
    <>
      ListPickPage
      {lists !== null && theseStores.length && !loading && (
        <>
          <div className="text-center text-3xl p-10 font-bold text-slate-800">
            Let's get <div className="text-emerald-400">shoppin'!</div>
            <div className="mt-10 flex flex-col gap-10">{listStatus}</div>
          </div>
        </>
      )}
    </>
  )
}
